import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Header from "./components/partials/Header";
import Menu from "./components/partials/Menu";
import SideBar from "./components/partials/SideBar";
import FullPageLoader from "./constants/FullPageLoader";

import { AlertProvider } from "./context/AlertContext";
import { AuthProvider, useAuth } from "./context/AuthProvider";
import PrivateRoute from "./context/PrivateRoute";
import { NetworkProvider } from "./context/NetworkContext";
import { PermissionProvider } from "./context/PermissionContext";
import { ContextApiProvider } from "./context/ContextApi";

import Login from "./components/pages/login/Login";
import VerifyOtp from "./components/pages/login/VerifyOtp";
import AuthStore from "./components/pages/login/AuthStore";
import Register from "./components/pages/login/Register";
import AuthLogin from "./components/pages/login/AuthLogin";
import ForgotPassword from "./components/pages/login/ForgotPassword";
import Success from "./components/pages/login/Success";
import ResetPassword from "./components/pages/login/ResetPassword";
import UpdatePassword from "./components/pages/login/UpdatePassword";
import AuthStaff from "./components/pages/login/AuthStaff";

import Dashboard from "./components/pages/Dashboard";
import Customer from "./components/pages/customer/Customer";
import Product from "./components/pages/product/Product";
import ListProduct from "./components/pages/product/ListProduct";

import Stock from "./components/pages/stockbatch/Stock";
import ListStock from "./components/pages/stockbatch/ListStock";
import StockAvailable from "./components/pages/stock/StockAvailable";

import Sale from "./components/pages/sale/Sale";
import ListSale from "./components/pages/sale/ListSale";
import EditSale from "./components/pages/sale/EditSale";

import StockTransfer from "./components/pages/stocktransfer/StockTransfer";
import ListStockTransfer from "./components/pages/stocktransfer/ListStockTransfer";
import StockArrival from "./components/pages/stocktransfer/StockArrival";

import StockTrash from "./components/pages/stock/StockTrash";

import SalesReport from "./components/pages/report/SalesReport";
import Gstr1Report from "./components/pages/report/Gstr1Report";
import HsnReport from "./components/pages/report/HsnReport";

import Store from "./components/pages/store/Store";
import InviteSub from "./components/pages/store/InviteSub";
import InviteHub from "./components/pages/store/InviteHub";
import AccessStore from "./components/pages/store/AccessStore";
import Setting from "./components/pages/settings/Setting";
import Paylater from "./components/pages/paylater/Paylater";
import Boxcash from "./components/pages/boxcash/Boxcash";
import Estimate from "./components/pages/estimation/Estimate";
import ListEstimate from "./components/pages/estimation/ListEstimate";
import EditEstimate from "./components/pages/estimation/EditEstimate";
import SubStock from "./components/pages/stockbatch/substock/SubStock";
import ListSubStock from "./components/pages/stockbatch/substock/ListSubStock";

import ConfirmDetele from "./components/pages/account/ConfirmDetele";
import AccountDeletionTerms from "./components/pages/account/AccountDeletionTerms";
import Expense from "./components/pages/expense/Expense";
import Profile from "./components/pages/profile/Profile";
import Recharge from "./components/pages/recharge/Recharge";
import ProductReport from "./components/pages/report/ProductReport";
import ProfitLossReport from "./components/pages/report/ProfitLossReport";
import { RouteTracker } from "./context/LocationTracker";
import Analytics from "./components/pages/analytics/Analytics";
import ExpanseReport from "./components/pages/expense/ExpanseReport";
import ListService from "./components/pages/service/ListService";
import ListJobCard from "./components/pages/jobcard/ListJobcard";
import MyList from "./components/pages/estimation/MyList";
import AllCustomer from "./components/pages/customer/AllCustomer";
import AllListProduct from "./components/pages/product/AllListProduct";
import Voucher from "./components/pages/voucher/Voucher";
import StockReport from "./components/pages/report/StockReport";
import Purchase from "./components/pages/purchase/Purchase";
import Supplier from "./components/pages/supplier/Supplier";
import { arrayMove } from "@dnd-kit/sortable";
import CustomerExcelUploader from "./components/pages/customer/CustomerUpload";
import ProductExcelUploader from "./components/pages/product/UploadProduct";
import AxiosInstance, { startApiIdleWatcher } from "./utils/AxiosInstance";
import SupplierExcelUploader from "./components/pages/supplier/SupplierUpload";
import ListPurchase from "./components/pages/purchase/ListPurchase";
import ServiceDoneByReport from "./components/pages/report/ServiceDoneByReport";
import ListReturnSale from "./components/pages/ReturnSale/ListReturnSale";
import ReturnSale from "./components/pages/ReturnSale/RetrunSale";
import StaffListSale from "./components/pages/sale/StaffListSale";
import OldEditSale from "./components/pages/sale/OldEditSale";
import ListProject from "./components/pages/project/ListProject";
import ViewProject from "./components/pages/project/ViewProject";
import SaleTransactions from "./components/pages/report/SalesTransactions";
import ReturnSalesReport from "./components/pages/report/RetrunSaleReport";
import GlobalErrorBoundary from "./constants/ErrorFallback";
import { SaleProvider } from "./context/SaleContext";
import Porforma from "./components/pages/porforma/porforma";
import ListPreSale from "./components/pages/preSale/listPreSale";
import EditProforma from "./components/pages/porforma/EditProforma";
import ResetAccount from "./components/pages/login/ResetAccount";
import VerifyResetAccountOtp from "./components/pages/login/VerifyRestOtp";
import ConfirmResetAccount from "./components/pages/login/ConfirmResetAccount";

const RedirectToNegoBill = () => {
  useEffect(() => {
    window.location.replace("https://negobill.com/");
  }, []);

  return null;
};

function App() {
  // useEffect(() => {
  //   const bar = document.getElementById("top-loader");

  //   if (bar) {
  //     const inner = document.getElementById("top-bar");

  //     // complete animation
  //     if (inner) inner.style.width = "100%";

  //     setTimeout(() => {
  //       bar.style.opacity = "0";
  //       bar.style.transition = "opacity 0.3s";
  //       setTimeout(() => bar.remove(), 300);
  //     }, 200);
  //   }
  // }, []);
  useEffect(() => {
    const loader = document.getElementById("app-loader");
    const circle = document.getElementById("progress-circle");
    const text = document.getElementById("progress-text");

    if (!loader || !circle) return;

    const radius = 35;
    const circumference = 2 * Math.PI * radius;

    //  Complete to 100%
    const offset = circumference - (100 / 100) * circumference;
    circle.style.strokeDashoffset = offset;

    if (text) text.innerText = "100%";

    //  Fade out and remove
    setTimeout(() => {
      loader.style.opacity = "0";
      loader.style.transition = "opacity 0.3s";

      setTimeout(() => {
        loader.remove();
      }, 300);
    }, 300);
  }, []);

  useEffect(() => {
    startApiIdleWatcher(async () => {
      return await AxiosInstance.get("module/store/warmup");
    });
  }, []);
  return (
    <Router>
      <RouteTracker />
      <AlertProvider>
        <AuthProvider>
          <NetworkProvider>
            <PermissionProvider>
              <ContextApiProvider>
                <SaleProvider>
                  <GlobalErrorBoundary>
                    <MainContent />
                  </GlobalErrorBoundary>
                </SaleProvider>
              </ContextApiProvider>
            </PermissionProvider>
          </NetworkProvider>
        </AuthProvider>
      </AlertProvider>
    </Router>
  );
}

function MainContent() {
  const location = useLocation();
  const { isUser, isLoading } = useAuth();
  const [isSideMenuOpen, setSideMenuOpen] = useState(false);
  const navigate = useNavigate();
  // const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const [openTabs, setOpenTabs] = useState([]);
  const prevPathRef = useRef(null);
  // useEffect(() => {
  //   if (location.state?.modalData) {
  //     setViewData(location.state.modalData);
  //     setViewModalOpen(true);
  //   }
  // }, [location.state]);
  // useEffect(() => {
  //   const path = location.pathname;
  //   const excludedPaths = ["/", "/login", "/dashboard", "/sale"];

  //   if (isUser && !excludedPaths.includes(path) && COMPONENT_MAP[path]) {
  //     const exists = openTabs.find((t) => t.path === path);
  //     if (!exists) {
  //       const name = path.substring(1).charAt(0).toUpperCase() + path.slice(2);
  //       setOpenTabs((prev) => [...prev, { path, name }]);
  //     }
  //   }
  // }, [location.pathname, isUser]);

  const closeTabs = (pathsToClose, fallbackPath = "/dashboard") => {
    setOpenTabs((prevTabs) => {
      const currentIndex = prevTabs.findIndex(
        (tab) => tab.path === location.pathname,
      );

      const remainingTabs = prevTabs.filter(
        (tab) => !pathsToClose.includes(tab.path),
      );

      // ✅ If current tab is NOT found → fallback immediately
      if (currentIndex === -1) {
        navigate(fallbackPath);
        return remainingTabs;
      }

      if (pathsToClose.includes(location.pathname)) {
        let nextPath = fallbackPath;

        if (currentIndex > 0) {
          nextPath = prevTabs[currentIndex - 1]?.path;
        } else if (prevTabs[currentIndex + 1]) {
          nextPath = prevTabs[currentIndex + 1]?.path;
        }

        navigate(nextPath);
      }

      return remainingTabs;
    });
  };

  const getParentPath = (path, prevPath) => {
    // 🎯 Context-based rules
    if (path === "/editsale" && prevPath === "/sale") {
      return "/sale";
    }

    if (path === "/editsale" && prevPath === "/customer") {
      return "/customer";
    }

    if (path === "/editestimate" && prevPath === "/customer") {
      return "/customer";
    }

    // Default parent mapping
    const map = {
      "/product": "/allproduct",
      "/estimate": "/listestimation",
      "/editestimate": "/listestimation",
      "/editsale": "/listsale",
      "/stock": "/liststock",
    };

    return map[path];
  };

  const closeEstimateTabs = () => {
    closeTabs(["/estimate", "/editestimate"], "/listestimation");
  };

  const closeCustomerUploadTabs = () => {
    closeTabs(["/customer-upload"], "/customer");
  };

  const closeProductUploadTabs = () => {
    closeTabs(["/product-upload"], "/allproduct");
  };

  const closeAddProductTabs = () => {
    closeTabs(["/product"], "/allproduct");
  };

  const closeEditSaleTabs = () => {
    closeTabs(["/editsale"], "/listsale");
  };

  const closeEditProformaTab = () => {
    closeTabs(["/editproforma"], "/listpresale");
  };

  const closeRetrunSaleTabs = () => {
    closeTabs(["/returnsale"], "/listreturnsale");
  };

  const closeoldEditSaleTabs = () => {
    closeTabs(["/editsaleold"], "/listsale");
  };

  const closeSupplierUploadTabs = () => {
    closeTabs(["/supplier-upload"], "/supplier");
  };

  const closeAddPurchseTabs = () => {
    closeTabs(["/purchase"], "/listpurchase");
  };

  const TAB_NAME_MAP = {
    "/dashboard": "Dashboard",

    "/customer": "Customer",
    "/allcustomer": "All Customers",

    "/product": "Add Product",
    "/allproduct": "All Products",
    "/listproduct": "List Product",

    "/sale": "Sale",
    "/listsale": "List Sale",
    "/editsale": "Edit Sale",
    "/stafflistsale": "Staff List Sale",
    "/editsaleold": "Edit Sale",

    "/listreturnsale": "List Return Sale",

    "/estimate": "Add Estimate",
    "/listestimation": "List Estimate",
    "/editestimate": "Edit Estimate", // ✅ FIXED

    "/stock": "Stock",
    "/liststock": "List Stock",
    "/listProject": "Project",
    "/ViewProject": "View Project",

    "/liststocktransfer": "List StockTransfer",
    "/stocktransfer": "Add StockTransfer",
    "/service-doneby-report": "Service Done By Report",
    "/sale-transactions": "Sale Transactions",
    "/saleretrun-report": "Sale Return Report",

    "/listpresale": "Pre Sale",
    "/listpurchase": "List Purchase",
  };

  const COMPONENT_MAP = {
    "/dashboard": <Dashboard />,

    "/customer": <Customer />,
    "/allcustomer": <AllCustomer />,

    "/product": <Product onDone={closeAddProductTabs} />,
    "/allproduct": <AllListProduct />,
    "/listproduct": <ListProduct />,

    "/listservice": <ListService />,
    "/supplier": <Supplier />,

    "/stock": <Stock />,
    "/liststock": <ListStock />,
    "/stockavailable": <StockAvailable />,
    "/stocktrash": <StockTrash />,
    "/substock": <SubStock />,
    "/listsubStock": <ListSubStock />,

    "/stocktransfer": <StockTransfer />,
    "/liststocktransfer": <ListStockTransfer />,

    "/stockarrival": <StockArrival />,

    "/sale": <Sale />,
    "/listsale": <ListSale />,
    "/editsale": <EditSale onDone={closeEditSaleTabs} />,
    "/editsaleold": <OldEditSale onDone={closeoldEditSaleTabs} />,

    "/stafflistsale": <StaffListSale />,

    "/listreturnsale": <ListReturnSale />,
    "/returnsale": <ReturnSale onDone={closeRetrunSaleTabs} />,

    "/estimate": <Estimate onDone={closeEstimateTabs} />,
    "/listestimation": <ListEstimate />,
    "/editestimate": <EditEstimate onDone={closeEstimateTabs} />,
    "/mylist": <MyList />,

    "/sales-report": <SalesReport />,
    "/gstr1-report": <Gstr1Report />,
    "/hsn-report": <HsnReport />,
    "/product-report": <ProductReport />,
    "/profitloss-report": <ProfitLossReport />,
    "/expanse-report": <ExpanseReport />,
    "/stock-report": <StockReport />,
    "/service-doneby-report": <ServiceDoneByReport />,

    "/store": <Store />,
    "/setting": <Setting />,

    "/paylater": <Paylater />,
    "/boxcash": <Boxcash />,
    "/recharge": <Recharge />,

    "/confirm-delete": <ConfirmDetele />,

    "/expense": <Expense />,
    "/profile": <Profile />,
    "/analytics": <Analytics />,

    "/listjobcard": <ListJobCard />,
    "/listProject": <ListProject />,
    "/ViewProject": <ViewProject />,
    "/voucher": <Voucher />,

    "/purchase": <Purchase onDone={closeAddPurchseTabs} />,
    "/listpurchase": <ListPurchase />,
    "/customer-upload": (
      <CustomerExcelUploader onDone={closeCustomerUploadTabs} />
    ),
    "/product-upload": <ProductExcelUploader onDone={closeProductUploadTabs} />,
    "/supplier-upload": (
      <SupplierExcelUploader onDone={closeSupplierUploadTabs} />
    ),

    "/sale-transactions": <SaleTransactions />,
    "/saleretrun-report": <ReturnSalesReport />,

    "/Proforma": <Porforma />,
    "/listpresale": <ListPreSale />,
    "/editproforma": <EditProforma onDone={closeEditProformaTab} />,
  };

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const path = location.pathname;

    const excludedPaths = ["/", "/login", "/dashboard", "/sale"];

    if (!isUser || excludedPaths.includes(path) || !COMPONENT_MAP[path]) {
      prevPathRef.current = path;
      return;
    }

    setOpenTabs((prevTabs) => {
      let name = TAB_NAME_MAP[path] || path.replace("/", "");

      // Proforma
      if (path === "/Proforma") {
        const mode = (location.state?.mode || "proforma").toLowerCase();

        if (mode === "quotation") {
          name = "Quotation";
        } else if (mode === "estimation") {
          name = "Estimation";
        } else {
          name = "Proforma";
        }
      }

      // Edit Proforma
      if (path === "/editproforma") {
        const mode = (location.state?.preSaleMode || "proforma").toLowerCase();

        if (mode === "quotation") {
          name = "Edit Quotation";
        } else if (mode === "estimation") {
          name = "Edit Estimation";
        } else {
          name = "Edit Proforma";
        }
      }

      const existingIndex = prevTabs.findIndex((t) => t.path === path);

      if (existingIndex !== -1) {
        const updated = [...prevTabs];
        updated[existingIndex] = {
          ...updated[existingIndex],
          name,
        };
        return updated;
      }

      const parentPath = getParentPath(path, prevPath);
      const parentIndex = prevTabs.findIndex((t) => t.path === parentPath);

      if (parentIndex !== -1) {
        const copy = [...prevTabs];
        copy.splice(parentIndex + 1, 0, { path, name });
        return copy;
      }

      return [...prevTabs, { path, name }];
    });

    prevPathRef.current = path;
  }, [location.pathname, location.state, isUser]);

  // const handleClose = () => {
  //   setViewModalOpen(false);
  //   setViewData(null);
  //   navigate(location.pathname, { replace: true, state: {} });
  // };

  const toggleSideMenu = () => {
    setSideMenuOpen(!isSideMenuOpen);
  };

  if (isLoading) return <FullPageLoader isLoading={isLoading} />;
  const deleteAccountPaths = ["/delete-account", "/confirm-delete", "/reset"];
  const isDeleteAccountRoute = deleteAccountPaths.includes(location.pathname);

  const handleOpenTab = (path, name) => {
    if (path === "/dashboard" || path === "/sale") {
      navigate(path);
      return;
    }
    if (!openTabs.find((tab) => tab.path === path)) {
      setOpenTabs([...openTabs, { path, name }]);
    }
    navigate(path);
  };

  //  const handleCloseTab = (e,path) => {
  //   if (e) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //   }
  //     const remainingTabs = openTabs.filter(tab => tab.path !== path);
  //     setOpenTabs(remainingTabs);

  //     if (location.pathname === path) {
  //       const nextTab = remainingTabs.length > 0 ? remainingTabs[remainingTabs.length - 1].path : "/dashboard";
  //       navigate(nextTab);
  //     }
  //   };

  const handleCloseTab = (e, path) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setOpenTabs((prevTabs) => {
      const index = prevTabs.findIndex((tab) => tab.path === path);
      const remainingTabs = prevTabs.filter((tab) => tab.path !== path);

      // If closing the ACTIVE tab → decide where to go
      if (location.pathname === path) {
        let nextPath = "/dashboard";

        // Prefer PREVIOUS tab
        if (index > 0) {
          nextPath = prevTabs[index - 1].path;
        }
        // Else try NEXT tab
        else if (prevTabs[index + 1]) {
          nextPath = prevTabs[index + 1].path;
        }

        navigate(nextPath);
      }

      return remainingTabs;
    });
  };

  const handleReorderTabs = (activeId, overId) => {
    setOpenTabs((prev) => {
      const oldIndex = prev.findIndex((t) => t.path === activeId);
      const newIndex = prev.findIndex((t) => t.path === overId);
      return arrayMove(prev, oldIndex, newIndex);
    });
  };

  return (
    <>
      {isUser && !isDeleteAccountRoute && (
        <>
          <Header
            toggleSideMenu={toggleSideMenu}
            isSideMenuOpen={isSideMenuOpen}
          />
          {isSideMenuOpen && (
            <SideBar
              toggleSideMenu={toggleSideMenu}
              onMenuClick={handleOpenTab}
            />
          )}
          <Menu
            isSideMenuOpen={isSideMenuOpen}
            tabs={openTabs}
            activeTab={location.pathname}
            onSelect={(path) => navigate(path)}
            onClose={(e, path) => handleCloseTab(e, path)}
            onReorder={handleReorderTabs}
          />
        </>
      )}

      <Routes>
        <Route
          path="/"
          element={isUser ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/login"
          element={isUser ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/auth"
          element={
            isUser ? <Navigate to="/dashboard" replace /> : <AuthLogin />
          }
        />
        <Route
          path="/verify"
          element={
            isUser ? <Navigate to="/dashboard" replace /> : <VerifyOtp />
          }
        />
        <Route path="/verify-reset" element={<VerifyResetAccountOtp />} />
        <Route
          path="/confirm-reset-account"
          element={<ConfirmResetAccount />}
        />
        <Route
          path="/authstore"
          element={
            isUser ? <Navigate to="/dashboard" replace /> : <AuthStore />
          }
        />
        {/* <Route
          path="/register"
          element={isUser ? <Navigate to="/dashboard" replace /> : <Register />}
        /> */}

        <Route path="/register" element={<RedirectToNegoBill />} />

        <Route
          path="/forgot"
          element={
            isUser ? <Navigate to="/dashboard" replace /> : <ForgotPassword />
          }
        />
        <Route
          path="/success"
          element={isUser ? <Navigate to="/dashboard" replace /> : <Success />}
        />
        <Route
          path="/authpassword"
          element={
            isUser ? <Navigate to="/dashboard" replace /> : <UpdatePassword />
          }
        />
        <Route
          path="/authstaff"
          element={
            isUser ? <Navigate to="/dashboard" replace /> : <AuthStaff />
          }
        />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/reset-account" element={<ResetAccount />} />

        <Route path="/invite-sub/:token" element={<InviteSub />} />
        <Route path="/invite-hub/:token" element={<InviteHub />} />
        <Route path="/access-store/:atoken/:rtoken" element={<AccessStore />} />
        <Route path="/delete-account" element={<AccountDeletionTerms />} />
        {!isUser && <Route path="/deletion-login" element={<Login />} />}

        {/* <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/customer" element={<Customer />} />
          <Route path="/allcustomer" element={<AllCustomer />} />

          <Route path="/supplier" element={<Supplier />} />

          <Route path="/product" element={<Product />} />
          <Route path="/listproduct" element={<ListProduct />} />
          <Route path="/allproduct" element={<AllListProduct />} />

          <Route path="/listservice" element={<ListService />} />

          <Route path="/stock" element={<Stock />} />
          <Route path="/liststock" element={<ListStock />} />
          <Route path="/stockavailable" element={<StockAvailable />} />
          <Route path="/stocktrash" element={<StockTrash />} />
          <Route path="/substock" element={<SubStock />} />
          <Route path="/listsubStock" element={<ListSubStock />} />

          <Route path="/stocktransfer" element={<StockTransfer />} />
          <Route path="/liststocktransfer" element={<ListStockTransfer />} />

          <Route path="/stockarrival" element={<StockArrival />} />

          <Route path="/sale" element={<Sale />} />
          <Route path="/listsale" element={<ListSale />} />
          <Route path="/editsale" element={<EditSale />} />

          <Route path="/estimate" element={<Estimate />} />
          <Route path="/listestimation" element={<ListEstimate />} />
          <Route path="/editestimate" element={<EditEstimate />} />
          <Route path="/mylist" element={<MyList />} />

          <Route path="/sales-report" element={<SalesReport />} />
          <Route path="/gstr1-report" element={<Gstr1Report />} />
          <Route path="/hsn-report" element={<HsnReport />} />
          <Route path="/product-report" element={<ProductReport />} />
          <Route path="/profitloss-report" element={<ProfitLossReport />} />
          <Route path="/expanse-report" element={<ExpanseReport />} />
          <Route path="/stock-report" element={<StockReport />} />

          <Route path="/store" element={<Store />} />
          <Route path="/setting" element={<Setting />} />

          <Route path="/paylater" element={<Paylater />} />
          <Route path="/boxcash" element={<Boxcash />} />
          <Route path="/recharge" element={<Recharge />} />

          <Route path="/stocktransfer" element={<StockTransfer />} />

          <Route path="/confirm-delete" element={<ConfirmDetele />} />

          <Route path="/expense" element={<Expense />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/analytics" element={<Analytics />} />

          <Route path="/listjobcard" element={<ListJobCard />} />
          <Route path="/voucher" element={<Voucher />} />

          <Route path="/purchase" element={<Purchase />} />
          <Route path="/listpurchase" element={<ListPurchase />} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route> */}
      </Routes>
      {isUser && (
        <PrivateRoute
          openTabs={openTabs}
          activePath={location.pathname}
          COMPONENT_MAP={COMPONENT_MAP}
        />
      )}
      {/* {isUser && (
      <div className="tab-content-container"> 
        <div style={{ display: location.pathname === '/dashboard' ? 'block' : 'none' }}>
          <Dashboard />
        </div>
      <div style={{ display: location.pathname === '/sale' ? 'block' : 'none' }}>
          <Sale />
        </div>
    {openTabs.map((tab) => (
      <div 
        key={tab.path} 
        style={{ display: location.pathname === tab.path ? 'block' : 'none' }}
      >
        {COMPONENT_MAP[tab.path]}
      </div>
    ))}
      </div>
        )} */}
    </>
  );
}

export default App;
